import { render, staticRenderFns } from "./historyreport.vue?vue&type=template&id=1dbc29fc&scoped=true&"
import script from "./historyreport.vue?vue&type=script&lang=js&"
export * from "./historyreport.vue?vue&type=script&lang=js&"
import style0 from "./historyreport.vue?vue&type=style&index=0&id=1dbc29fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc29fc",
  null
  
)

export default component.exports